export const errorsCode = {
  notEnoughGasForTransaction: "BLOCKCHAIN.INSUFFICIENT_FUNDS_FOR_GAS",
};
